import type { Subscription } from 'effector'
import type {
    ConfigPersist as BaseConfigPersist,
    ConfigSourceTarget as BaseConfigSourceTarget,
    ConfigStore as BaseConfigStore
} from '../types'
import { persist as base } from '../core'
import { adapter } from './adapter'

export type { Contract, Done, Fail, Finally, StorageAdapter, StorageAdapterFactory } from '../types'
export type { MemoryConfig } from './adapter'

export type ConfigPersist = BaseConfigPersist

export type ConfigStore<State, Err = Error> = BaseConfigStore<State, Err>

export type ConfigSourceTarget<State, Err = Error> = BaseConfigSourceTarget<State, Err>

export interface Persist {
    <State, Err = Error>(config: ConfigSourceTarget<State, Err>): Subscription

    <State, Err = Error>(config: ConfigStore<State, Err>): Subscription
}

/**
 * Returns memory adapter
 */
export { adapter as memory }

/**
 * Creates custom partially applied `persist`
 * with predefined `memory` adapter
 */
export function createPersist(defaults?: ConfigPersist): Persist {
    return (config) =>
        base({
            adapter: adapter(),
            ...defaults,
            ...config
        })
}

/**
 * Default partially applied `persist`
 */
export const persist = createPersist()
